import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="notification-container">
      <div *ngFor="let notification of notifications()"
           [@fadeInOut]
           class="notification"
           [ngClass]="notification.type">
        {{ notification.message }}
        <button class="close-button" aria-label="Schließen" (click)="removeNotification(notification.id)">×</button>
      </div>
    </div>
  `,
  styles: [`
    .notification-container {
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 1000;
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-width: 400px;
    }

    .notification {
      padding: 15px 40px 15px 15px;
      border-radius: 4px;
      color: white;
      position: relative;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    }

    .error {
      background-color: #dc3545;
    }

    .success {
      background-color: #28a745;
    }

    .info {
      background-color: #17a2b8;
    }

    .close-button {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      color: white;
      font-size: 20px;
      cursor: pointer;
      padding: 0 5px;
    }

    .close-button:hover {
      opacity: 0.8;
    }
  `],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
      ])
    ])
  ]
})
export class NotificationComponent {
  // Signal des Service wird direkt übernommen (kein manuelles subscribe()/ngOnInit mehr nötig) -
  // das Template liest es per notifications() selbst aus. Da keine Subscription mehr existiert,
  // gibt es auch keine ngOnDestroy()-Unsubscribe-Logik mehr zu vergessen (siehe vorheriger
  // Memory-Leak-Bug in der Git-Historie).
  notifications = this.notificationService.getNotifications();

  constructor(private notificationService: NotificationService) {}

  removeNotification(id: number) {
    this.notificationService.remove(id);
  }
}